import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router';

const AccountUnavailable= () => {
  const { t } = useTranslation();

  return (
      <div className="popup-inner admin-msg" style={{ maxWidth: '650px' }}>
        <div className="popup-title">{t('admin_msg_modal_title')}</div>
        <div className="popup-content">
          <div className="popup-content--icon">
            <img src="/assets/images/alert.svg" alt="alert logo" />
          </div>
          <div className="popup-content--text">
            <h1 className="popup-content--text--title">{t("account_unavailable_title")}</h1>
            <p className="popup-content--text--alert">{t("account_unavailable_content")}</p>
          </div>
        </div>
    </div>
  );
}

export default withRouter(AccountUnavailable);